import React from "react";
import { Checkbox } from "antd";
import { Link } from "react-router-dom";
import { appRoutesConst } from "app/navigation";

export default function TermsAndAckowledgeCheckbox({
  handleCheckbox,
  isAllowAlerts,
  isTermsAccepted,
  onlyAlerts,
  errors,
  fromSticky,
}) {
  return (
    <div className={`mt-3 bottom-checkbox-list ${onlyAlerts ? "" : "ml-0"}`}>
      <Checkbox
        // onChange={(e) => {
        //   handleCheckbox(e, "isAllowAlerts");
        // }}
        className={`date-checkbox mb-3 w-100 ${onlyAlerts ? "margin-reset" : ""} `}
        // checked={isAllowAlerts}
      >
        <span
          className={`${
            !fromSticky ? "" : ""
          } font-weight-500 text-capitalize`}
        >
          I want to receive news ,feature updates, and marketing SMS and email
          messages.
        </span>
      </Checkbox>
      {!onlyAlerts && (
        <Checkbox
          onChange={(e) => {
            handleCheckbox(e, "isTermsAccepted");
          }}
          className="date-checkbox margin-reset mb-3"
          checked={isTermsAccepted}
        >
          <span
            className={`${
              !fromSticky ? "" : ""
            } font-weight-500 text-capitalize`}
          >
            I read and agreed to the{" "}
            <Link target="_blank" to={appRoutesConst.termsandconditions}>
              {" "}
              Terms and Conditions
            </Link>{" "}
            by{" "}
            <span className="font-weight-semibold">Chicago Hajj & Umrah.</span>
          </span>
        </Checkbox>
      )}
      <p>
        {errors && (
          <span className="text-danger">{errors.isTermsAccepted}</span>
        )}
      </p>
    </div>
  );
}
